module.exports = __webpack_public_path__ + "static/Forager-build-19a5bca862bdc4c61e1067e5a2354673.webp";